// services/abandonedCartService/utm.ts — tangkap UTM utk save cart (satu-satunya sumber)
// Cermin logika submitPayload.ts: ?platform= fallback bila tanpa utm_source,
// fbclid/gclid/ttclid → platform, lalu canonPlatform (tak dikenal → '').
import { canonPlatform } from '../platforms.js';

export interface CartUtm {
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmTerm: string;
  utmContent: string;
}

export function captureCartUtm(): CartUtm {
  try {
    const sp = new URLSearchParams(window.location.search);
    let raw = sp.get('utm_source') || '';
    const platformVal = sp.get('platform') || '';
    if (platformVal && !raw) raw = platformVal;
    if (!raw) {
      if (sp.has('fbclid')) raw = 'meta';
      else if (sp.has('gclid')) raw = 'google';
      else if (sp.has('ttclid')) raw = 'tiktok';
    }
    return {
      utmSource: canonPlatform(raw, ''),
      utmMedium: sp.get('utm_medium') || '',
      utmCampaign: sp.get('utm_campaign') || '',
      utmTerm: sp.get('utm_term') || '',
      utmContent: sp.get('utm_content') || '',
    };
  } catch {
    return { utmSource: '', utmMedium: '', utmCampaign: '', utmTerm: '', utmContent: '' };
  }
}
